import { Flex } from '@chakra-ui/react';
import { Card } from '@main/complykit/components/card';
import { Content } from '@main/complykit/components/slots';
import { Integration_Names_Enum } from '@main/graphql/types.generated';
import type { ReactNode } from 'react';

import { IntegrationDetails } from '../integration-details';
import { IntegrationLogo } from '../integration-logo';

export type AppConnectorCardFrameProps = {
  providerName: Integration_Names_Enum;
  connectorName?: string;
  helpMessage?: string;
  actions?: ReactNode;
  children?: ReactNode;
};

export const AppConnectorCardFrame = ({
  providerName,
  connectorName,
  helpMessage,
  actions,
  children,
}: AppConnectorCardFrameProps) => {
  return (
    <Card>
      <Content>
        <Flex align="start" gap={4}>
          <IntegrationLogo name={providerName} />
          <Flex grow={1}>
            <IntegrationDetails
              providerName={providerName}
              connectorName={connectorName}
              helpMessage={helpMessage}
            />
          </Flex>
          {actions && <Flex gap={2}>{actions}</Flex>}
        </Flex>
        {children}
      </Content>
    </Card>
  );
};
